import React, { useRef } from "react";
import { useTheme } from "../../context/ThemeContext.jsx";
import ModalOrSheet from "./ModalOrSheet.jsx";
import AppButton from "./AppButton.jsx";
import { Textarea } from "../forms/shared/FormAtoms.jsx";
export default function ArchiveReasonDialog({
  open,
  onClose,
  onConfirm,
  title = "Eintrag archivieren",
  subtitle = "",
  loading = false,
  placeholder = "Kurz begruenden...",
  requireReason = false,
}) {
    const inputRef = useRef(null);
  return <ModalOrSheet open={open} onClose={onClose} title={title} maxWidth="sm">
      <div className="space-y-3">
        {subtitle ? <div className={"text-xs text-blue-200/70 line-clamp-2"} title={subtitle}>
            {subtitle}
          </div> : null}
        <label className={"text-sm text-blue-200/80 font-medium block"}>
          Grund{requireReason ? " (Pflicht)" : " (optional)"}
        </label>
        <Textarea ref={inputRef} className={`w-full border rounded p-2 min-h-[120px] ${"bg-[#0b1324] text-blue-100 border-white/10 placeholder-blue-200/40"}`} placeholder={placeholder} />
        <div className="mt-4 flex flex-wrap gap-2 justify-end">
          <AppButton type="button" variant="secondary" className="font-normal" onClick={onClose}>
            Abbrechen
          </AppButton>
          <AppButton type="button" variant="primary" disabled={loading} className="font-normal disabled:opacity-60" onClick={() => {
            const value = (inputRef.current?.value || "").trim();
            if (requireReason && !value) return;
            onConfirm(value);
          }}>
            {loading ? "Archiviere..." : "Archivieren"}
          </AppButton>
        </div>
      </div>
    </ModalOrSheet>;
}